const Triangle = props => (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Triangle</title>
    <polygon id="Triangle" points="12 0 0 24 24 24" />
  </svg>
);

export { Triangle };
